module.exports = __webpack_public_path__ + "static/img/solve1.c9b976c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/solve1.png
// module id = Pw+u
// module chunks = 1